import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import Segment from "../../../../common/element/Segment";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import SmallButton from "../../../../common/element/Buttons/btnPrimary";
import * as userActions from "../../../../actions/index";
import imagePlus from "../../../../assets/icons-svg/image-plus.svg";
import Validations from "../../../../common/404/Validations";
import { ResetProviderSignUpData } from "../../../../redux/classes/provider-portal/SignUp";
import Select from "../../../../common/element/Select/Select";
import { GetClientUserPermByIdForClient } from "../../../../actions/client-portal/AllUsersApi";
import { GetAlreadyExistingOrgCheck } from "../../../../actions/client-portal/AllSettingApis";
import Dialog from "../../../../common/element/Dialog";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import {
  GettData,
  ResetData,
} from "../../../../redux/classes/common/ProviderRegisterData";
import { GetAllOrgIndustryTypeList } from "../../../../actions/index";
import Label from "../../../../common/element/Label";
import Input from "../../../../common/element/Input";
import { Link } from "react-router-dom";
import Radio from "../../../../common/element/Radio";
import Tooltip from "../../../../common/element/Tooltip";
import { useSelector } from "react-redux";
import { RegistrationValidationCheck } from "../../../../redux/classes/common/RegistrationValidation";
import { GetIndividualByEmail } from "../../../../actions/public/GetIndividualByEmail";
import preventInvalidChars from "../../../../utils/preventInvalidChars";
import { GetAllContactTypes } from "../../../../actions/index";
import { setCountries, setStates } from "../../../../redux/classes/CountriesAndStates";
const YourBusiness = ({ UpdateData }) => {
  // Get Register Data
  const { SignUpData } = useSelector((state) => state);
  const { ProviderRegisterData } = useSelector((state) => state);
  const { RegistrationValidation } = useSelector((state) => state);
  const isFirstRender = useRef(true); // Flag to check if it's the first render
  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const [logo, setLogo] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [urlImage, setUrlImage] = useState("");
  const [dialogAddOpen, setdialogAddOpen] = useState(false);
  const [StateOptions2, setStateOptions2] = useState();
  const [mailingStateID, setMailingStateID] = useState("");
  const [countryOptions, setCountryOptions] = useState();
  const [checkEmail, setCheckEmail] = useState(false);
  const [visibleHide, setVisibleHide] = useState(false);
  const [mailingCountryID, setMailingCountryID] = useState("");
  const [formData, setFormData] = useState({
    trading_name: "",
    // provider_org_detail_id: "",
    abn_nzbn: "",
    // acn: "",
    no_of_emp: "0",
    ind_master_setting_id: "",
    businessAddres1: "",
    businessAddres2: "",
    businessAddresCity: "",
    businessAddresPostCode: "",
    businessAddresState: "",
    businessAddresCountry: "",
    businessId: "",

    mailingAddres1: "",
    mailingAddres2: "",
    mailingAddresCity: "",
    mailingAddresPostCode: "",
    mailingAddresState: "",
    mailingAddresCountry: "",
    mailingId: "",
  });
  const [formErrors, setFormErrors] = useState({
    title: "",
    abn_nzbn: "",
    no_of_emp: "",
    ind_master_setting_id: "",
    trading_name: "",
    businessAddres1: "",
    businessAddres2: "",
    businessAddresCity: "",
    businessAddresPostCode: "",
    businessAddresState: "",
    businessAddresCountry: "",

    mailingAddres1: "",
    mailingAddres2: "",
    mailingAddresCity: "",
    mailingAddresPostCode: "",
    mailingAddresState: "",
    mailingAddresCountry: "",
    org_type: "",
    existClient: "",
  });

  const businessRefs = {
    // Type of business
    org_type: useRef(null),

    // Business address
    businessAddres1: useRef(null),
    businessAddres2: useRef(null),
    businessAddresCity: useRef(null),
    businessAddresPostCode: useRef(null),
    businessAddresState: useRef(null),
    businessAddresCountry: useRef(null),

    // Mailing address
    mailingAddres1: useRef(null),
    mailingAddres2: useRef(null),
    mailingAddresCity: useRef(null),
    mailingAddresPostCode: useRef(null),
    mailingAddresState: useRef(null),
    mailingAddresCountry: useRef(null),

    // Details
    trading_name: useRef(null),
    abn_nzbn: useRef(null),
    ind_master_setting_id: useRef(null),
    no_of_emp: useRef(null),

    // Primary contact*
    // title: useRef(null),
  };
  const [organizationId, setOrganizationId] = useState("");
  const [parentLevel, setParentLevel] = useState("");
  const [allcountries, setAllCountries] = useState();
  const [statesOne, setStatesOne] = useState();
  const [statesTwo, setStatesTwo] = useState();
  const [contactTypeData, setContactTypeData] = useState(null);
  const [sameAddress, setSameAddress] = useState();
  const [businessAddresCountry, setBusinessAddresCountry] = useState("");
  const [documentError, setdocumentError] = useState("");
  const [industoryOptions, setIndustoryOptions] = useState([]);
  const [noOfEmp, setNoOfEmp] = useState([
    { label: "0-50", value: "0-50" },
    { label: "50-100", value: "50-100" },
    { label: "100-200", value: "100-200" },
    { label: "200-300", value: "200-300" },
    { label: "300-400", value: "300-400" },
    { label: "400-500", value: "400-500" },
  ]);
  const [businessAddresState, setBusinessAddresState] = useState("");
  const [mailingAddresCountry, setMailingAddresCountry] = useState("");
  const [mailingAddresState, setMailingAddresState] = useState("");
  const [value, setValue] = useState("Primary");
  const { ProviderContactData } = useSelector((state) => state);
  const [contact, SetContact] = useState([
    {
      providerContactType: "primary",
      title: "",
      first_name: "",
      last_name: "",
      phone: "",
      phone_optional: "",
      email: "",
      individual_id: "",
      pasword: "",
      contact_type_id: "",
    },
  ]);

  const [hasChanges, setHasChanges] = useState(false);
  const TitleOptions = [
    { value: "mr.", label: "Mr." },
    { value: "miss", label: "Miss" },
    { value: "mrs", label: "Mrs." },
    { value: "ms", label: "Ms." },
    { value: "dr", label: "Dr." },
  ];

  // state to set abn without having space
  const [abn, setAbn] = useState();
  const [callApi, setcallApi] = useState(false);

  let getApiData;
  let settings_permissions;
  let function_assignment_id;
  let user_id;
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  const permissionData = JSON.parse(localStorage.getItem("permission_data"));
  if (permissionData !== null) {
    settings_permissions = permissionData.settings_write;
  }
  if (storedData) {
    getApiData = {
      organisation_id: storedData.organisation_id,
    };
    user_id = storedData?.userName?.user_id;
    function_assignment_id = storedData.function_assignment_id;
  }

  function isElevenDigitNumber(value) {
    // Remove spaces and check if it's 11 digits
    if (value !== undefined && value !== "") {
      const strippedValue = value.replace(/\s/g, "");
      const numberRegex = /^\d{11}$/;
      return numberRegex.test(strippedValue);
    }
  }

  const GetAllStatesbyCountryId = useCallback(
    async (formData) => {
      if (formData.businessAddresCountry) {
        dispatch(
          userActions.GetAllStatesbyCountryId(formData.businessAddresCountry)
        ).then((response) => {
          if (response.success === true) {
            const arrayData = response.data;
            let state_data = [];
            for (let key in arrayData) {
              state_data.push({
                label: arrayData[key].state_name,
                value: arrayData[key].state_id,
              });
            }
            setStatesOne(state_data);
            //set redux store
            dispatch(setStates(state_data))
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          } else {
          }
        });
      }
      if (formData.mailingAddresCountry) {
        dispatch(
          userActions.GetAllStatesbyCountryId(formData.mailingAddresCountry)
        ).then((response) => {
          if (response.success === true) {
            const arrayData = response.data;
            let state_data = [];
            for (let key in arrayData) {
              state_data.push({
                label: arrayData[key].state_name,
                value: arrayData[key].state_id,
              });
            }
            setStatesTwo(state_data);
            setStateOptions2(state_data);
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          } else {
          }
        });
      }
      // eslint-disable-next-line
    },
    [dispatch, formData.businessAddresCountry, formData.mailingAddresCountry]
  );

  const GetAllCountries = useCallback(async () => {
    dispatch(userActions.GetAllCountries()).then((response) => {
      if (response.success === true) {
        const arrayData = response.data;
        let country_data = [];
        for (let key in arrayData) {
          country_data.push({
            label: arrayData[key].name,
            value: arrayData[key].country_id,
            country_id: arrayData[key].country_id,
          });
        }

        setCountryOptions(country_data);
        setAllCountries(country_data);
        dispatch(setCountries(country_data))
      } else if (response.status === 401) {
        handleUnauthorizedAccess();
      } else {
      }
    });
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    GetAllStatesbyCountryId(formData);
  }, [formData.businessAddresCountry, formData.mailingAddresCountry]);


  // useEffect(() => {
  //   return () => {
  //     dispatch(ResetProviderSignUpData());
  //   };
  // }, []);

  // Get all contect types
  const GetAllContact = () => {
    dispatch(GetAllContactTypes()).then((response) => {
      if (response.success) {
        // let data = response?.data.filter((item) => {
        //   if (item?.contact_type == "provider primary") {
        //     return { providerPrimary: item?.contact_type_id };
        //   } else if (item?.contact_type == "provider billing") {
        //     return { providerBilling: item?.contact_type_id };
        //   }
        // });
        let data = response?.data.reduce((acc, item) => {
          if (item?.contact_type === "provider primary") {
            acc.providerPrimary = item?.contact_type_id;
          } else if (item?.contact_type === "provider billing") {
            acc.providerBilling = item?.contact_type_id;
          }
          return acc;
        }, {});
        // SetContact((prevalue) => {
        //   return {
        //     ...prevalue,
        //     ["contact_type_id"]: data?.providerPrimary,
        //   };
        // });
        //         SetContact((prevalue) => {
        //   // Check if prevalue is an array, if not, initialize it as an empty array
        //   const previousArray = Array.isArray(prevalue) ? prevalue : [];

        //   // Create a new object with the updated data
        //   const newData = {
        //     ...data, // Spread the existing data
        //     contact_type_id: data?.providerPrimary, // Update the specific field
        //   };

        //   // Return the updated array with the new data appended
        //   return [...previousArray, newData];
        // });

        SetContact((prevValue) =>
          prevValue.map((contact, index) =>
            index === 0
              ? { ...contact, contact_type_id: data?.providerPrimary }
              : contact
          )
        );

        // SetContact((prevValue) => [
        //   { ...prevValue, contact_type_id: data?.providerPrimary },
        // ]);

        setContactTypeData(data);
      }
    });
  };
  const ClearError = () => {
    setFormErrors({
      title: "",
      abn_nzbn: "",
      no_of_emp: "",
      ind_master_setting_id: "",
      trading_name: "",
      businessAddres1: "",
      businessAddres2: "",
      businessAddresCity: "",
      businessAddresPostCode: "",
      businessAddresState: "",
      businessAddresCountry: "",
      mailingAddres1: "",
      mailingAddres2: "",
      mailingAddresCity: "",
      mailingAddresPostCode: "",
      mailingAddresState: "",
      mailingAddresCountry: "",
      org_type: "",
      existClient: "",
    });
  }
  useEffect(() => {
    //set invited abn 
    GetAllContact();
    GetAllCountries();
    setFormErrors({
      title: "",
      abn_nzbn: "",
      no_of_emp: "",
      ind_master_setting_id: "",
      trading_name: "",
      businessAddres1: "",
      businessAddres2: "",
      businessAddresCity: "",
      businessAddresPostCode: "",
      businessAddresState: "",
      businessAddresCountry: "",
      mailingAddres1: "",
      mailingAddres2: "",
      mailingAddresCity: "",
      mailingAddresPostCode: "",
      mailingAddresState: "",
      mailingAddresCountry: "",
      org_type: "",
      existClient: "",
    });
    setFormData({
      trading_name: "",
      // provider_org_detail_id: "",
      abn_nzbn: "",
      // acn: "",
      no_of_emp: "0",
      ind_master_setting_id: "",
      businessAddres1: "",
      businessAddres2: "",
      businessAddresCity: "",
      businessAddresPostCode: "",
      businessAddresState: "",
      businessAddresCountry: "",
      businessId: "",

      mailingAddres1: "",
      mailingAddres2: "",
      mailingAddresCity: "",
      mailingAddresPostCode: "",
      mailingAddresState: "",
      mailingAddresCountry: "",
      mailingId: "",
    })
    return () => {
      ClearError()
      dispatch(ResetData());
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (ProviderContactData?.provider_abn_nzbn) {
        setFormData((prevState) => ({
          ...prevState,
          abn_nzbn: (ProviderContactData?.provider_abn_nzbn)?.replace(/\s+/g, '')
        }))
      }
    }, 1000);

  }, [ProviderContactData?.provider_abn_nzbn])


  useEffect(() => {
    const delays = [20, 50, 200]; // Set the delays here in an array
    delays.forEach((delay) => {
      setTimeout(() => {
        ClearError(); // Reset errors after delay
      }, delay);
    });

    // Cleanup function to clear timeouts on unmount
    return () => {
      delays.forEach((delay) => clearTimeout(delay));
      dispatch(ResetData());
    };
  }, [])
  const inputchangehandler = (e, field) => {
    setFormErrors((prevalue) => {
      return {
        ...prevalue,
        [field]: "",
      };
    });
    let value;
    if (field == "ind_master_setting_id" || field == "no_of_emp") {
      if (e?.target?.value !== undefined) {
        value = e.target.value;
      } else {
        value = e.value;
      }
    } else if (field === "abn_nzbn") {
      if (e?.target?.value !== undefined) {
        value = e.target.value;
        // check validate ABN 
        if (isElevenDigitNumber(value.trim())) {
          const abnValidation = Validations({
            value: value,
            Validations: { required: true, ValidateABN: true },
          });
          if (!abnValidation?.valid) {
            setFormError("abn_nzbn", "Please enter valid ABN/NZBN");
          }
          else {
            setFormError("abn_nzbn", "");
          }
        } else {
          if (value.trim().length > 11) {
            setFormError("abn_nzbn", "Please enter valid ABN/NZBN");
          }
        }
        if (value.trim().length < 10) {
          setFormError("abn_nzbn", "");
        }
      } else {
        value = e.value;
      }
      value = value.replace(/\D/g, "");
    } else {
      if (e?.target?.value !== undefined) {
        value = e.target.value;
      } else {
        value = e.value;
      }
    }

    // if(field=="businessAddres1" ||field=="businessAddres2" || field=="mailingAddres1" ||field=="mailingAddres2"  ){
    if (value && value.length >= 255) {
      setFormErrors((prevValue) => ({
        ...prevValue,
        [field]: "Your text limit reached 255 characters",
      }));
    } else {
      // Clear the error if the value length is less than 255
      if (field != "abn_nzbn") {
        setFormErrors((prevValue) => ({
          ...prevValue,
          [field]: "",
        }));
      }
      setFormData({ ...formData, [field]: value });
    }

    // setFormErrors((prevalue)=>{
    //   return{
    //     ...prevalue,[field]:"Your text limit reached 255"
    //   }
    // })
    // }
    // else{
    //   setFormData({ ...formData, [field]: value });
    // }

    setHasChanges(true);
  };

  const handleFocusWebsite = () => {
    // Check if the current value doesn't already start with "www"
    // if (!formData.website_url.startsWith("www")) {
    //   setFormData({ ...formData, website_url: `www. ${formData.website_url}` });
    // }
  };

  // function to auto space in abn number
  const handleABN = () => {
    let newValue = formData.abn_nzbn.replace(/\D/g, ""); // Remove non-digit characters
    const length = newValue.length;
    if (length <= 11) {
      // newValue = `${newValue.slice(0, 2)} ${newValue.slice(2)}`;
      newValue = `${newValue.slice(0, 2)} ${newValue.slice(
        2,
        5
      )} ${newValue.slice(5, 8)} ${newValue.slice(8, 11)}`;
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      abn_nzbn: newValue,
    }));
    setAbn(newValue);
    let clientData = {
      trading_name: formData?.trading_name,
      abn_nzbn: formData?.abn_nzbn,
      organisation_id: organizationId,
    };

    // dispatch(GetAlreadyExistingOrgCheck(clientData)).then((response) => {
    //   if (response.success) {
    //     const arrayData = response.data;
    //     setFormErrors((prevFormErrors) => ({
    //       ...prevFormErrors,
    //       existClient: "",
    //     }));

    //     if (
    //       arrayData &&
    //       arrayData?.abn_nzbn == formData.abn_nzbn &&
    //       arrayData?.trading_name == formData.trading_name
    //     ) {
    //       // setClientExist(true)
    //       setFormErrors((prevFormErrors) => ({
    //         ...prevFormErrors,
    //         existClient:
    //           "The Name and ABN/NZBN you have provided are already registered on our system. In order to register as a new organisation, please choose a different name or ABN/NZBN",
    //       }));
    //     } else {
    //       // setClientExist(false)
    //     }
    //   } else if (response.status === 401) {
    //     handleUnauthorizedAccess();
    //   }
    // });
  };

  // function to handle business Type
  const onBusinessType = useCallback(
    (val) => {
      setBusinessType(val);
      setHasChanges(true);
      setFormErrors((prevError) => ({
        ...prevError,
        org_type: "",
      }))
    },
    [setBusinessType]
  );

  const handleCountryChange = (selectedOption, identifier) => {
    if (identifier === "businessAddress") {
      //  setbusinessCountryID(selectedOption.value)
      setFormError("businessAddresCountry", "");
      setFormData((prevFormData) => ({
        ...prevFormData,
        businessAddresCountry: selectedOption.value,
        businessAddresState: "",
      }));
      setBusinessAddresCountry(selectedOption);
    }
    if (identifier === "mailingAddress") {
      setFormError("mailingAddresCountry", "");
      setMailingCountryID(selectedOption.value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        mailingAddresCountry: selectedOption.value,
        mailingAddresState: "",
      }));
      setMailingStateID("");
      setMailingAddresCountry(selectedOption);
    }
    setHasChanges(true);
  };

  const handleStateChange = (selectedOption, identifier) => {
    if (identifier === "businessAddress") {
      //  setBusinessStateID(selectedOption.value)
      setFormError("businessAddresState", "");
      setFormData((prevFormData) => ({
        ...prevFormData,
        businessAddresState: selectedOption.value,
      }));
      setBusinessAddresState(selectedOption);
    }
    if (identifier === "mailingAddress") {
      setMailingStateID(selectedOption.value);
      setFormError("mailingAddresState", "");
      setFormData((prevFormData) => ({
        ...prevFormData,
        mailingAddresState: selectedOption.value,
      }));
      setMailingAddresState(selectedOption);
    }
    setHasChanges(true);
  };
  const setFormError = (field, message) => {
    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [field]: message,
    }));
  };

  const submitClient = (e) => {
    dispatch(RegistrationValidationCheck(false));
    if (!formErrors.existClient) {
      if (!sameAddress) {
        const errors = [];
        // clearFormErrors();

        //Business address
        const add1BusinessValidation = Validations({
          value: formData.businessAddres1,
          Validations: { required: true },
        });
        const cityBusinessValidation = Validations({
          value: formData.businessAddresCity,
          Validations: { required: true },
        });
        const postCodeBusinessValidation = Validations({
          value: formData.businessAddresPostCode,
          Validations: { required: true },
        });
        const countryBusinessValidation = Validations({
          value: formData.businessAddresCountry,
          Validations: { required: true },
        });
        const stateBusinessValidation = Validations({
          value: formData.businessAddresState,
          Validations: { required: true },
        });

        //Mailing address
        const add1MailingValidation = Validations({
          value: formData.mailingAddres1,
          Validations: { required: true },
        });
        const cityMailingValidation = Validations({
          value: formData.mailingAddresCity,
          Validations: { required: true },
        });
        const postCodeMailingValidation = Validations({
          value: formData.mailingAddresPostCode,
          Validations: { required: true },
        });
        const countryMailingValidation = Validations({
          value: formData.mailingAddresCountry,
          Validations: { required: true },
        });
        const stateMailingValidation = Validations({
          value: formData.mailingAddresState,
          Validations: { required: true },
        });

        // Type of Business
        const typeValidation = Validations({
          value: businessType,
          Validations: { required: true },
        });
        if (!typeValidation.valid) {
          setFormError("org_type", "This is required!");
          errors.push("org_type");
        }

        //Business address
        if (!add1BusinessValidation.valid) {
          setFormError("businessAddres1", add1BusinessValidation.error_msg);
          errors.push("businessAddres1");
        }
        if (!cityBusinessValidation.valid) {
          setFormError("businessAddresCity", cityBusinessValidation.error_msg);
          errors.push("businessAddresCity");
        }
        if (!postCodeBusinessValidation.valid) {
          setFormError(
            "businessAddresPostCode",
            postCodeBusinessValidation.error_msg
          );
          errors.push("businessAddresPostCode");
        }
        if (!countryBusinessValidation.valid) {
          setFormError(
            "businessAddresCountry",
            countryBusinessValidation.error_msg
          );
          errors.push("businessAddresCountry");
        }
        if (!stateBusinessValidation.valid) {
          setFormError(
            "businessAddresState",
            stateBusinessValidation.error_msg
          );
          errors.push("businessAddresState");
        }
        //Mailing address
        if (!add1MailingValidation.valid) {
          setFormError("mailingAddres1", add1MailingValidation.error_msg);
          errors.push(sameAddress ? "" : "mailingAddres1");

        }
        if (!cityMailingValidation.valid) {
          setFormError("mailingAddresCity", cityMailingValidation.error_msg);
          errors.push(sameAddress ? "" : "mailingAddresCity");
        }
        if (!postCodeMailingValidation.valid) {
          setFormError(
            "mailingAddresPostCode",
            postCodeMailingValidation.error_msg
          );
          errors.push(sameAddress ? "" : "mailingAddresPostCode");
        }
        if (!countryMailingValidation.valid) {
          setFormError(
            "mailingAddresCountry",
            countryMailingValidation.error_msg
          )
          errors.push(sameAddress ? "" : "mailingAddresCountry");
        }
        if (!stateMailingValidation.valid) {
          setFormError(
            "mailingAddresState",
            stateMailingValidation.error_msg
          );
          errors.push(sameAddress ? "" : "mailingAddresState");
        }

        // Details
        const nameValidation = Validations({
          value: formData.trading_name,
          Validations: { required: true },
        });
        const abnValidation = Validations({
          value: formData.abn_nzbn,
          Validations: { required: true, ValidateABN: true },
        });
        const ind_master_setting_id = Validations({
          value: formData.ind_master_setting_id,
          Validations: { required: true },
        });
        const requireNoEmp = ProviderContactData?.is_client_pay_licence === false;
        let no_of_emp;
        if (requireNoEmp) {
          no_of_emp = Validations({
            value: formData.no_of_emp,
            Validations: { required: true },
          });
        }
        if (!nameValidation.valid) {
          setFormError("trading_name", nameValidation.error_msg);
          errors.push("trading_name");
        }
        if (!abnValidation.valid) {
          setFormError("abn_nzbn", abnValidation.error_msg);
          errors.push("abn_nzbn");
        }
        if (!ind_master_setting_id.valid) {
          setFormError(
            "ind_master_setting_id",
            ind_master_setting_id.error_msg
          );
          errors.push("ind_master_setting_id");
        }
        if (requireNoEmp) {
          if (!no_of_emp.valid) {
            setFormError("no_of_emp", no_of_emp.error_msg);
            errors.push("no_of_emp");
          }
        } else {
          // Clear any lingering error if client pays
          setFormError("no_of_emp", "");
        }

        // Primary contact
        const title_primary = Validations({
          value: contact?.[0]?.title,
          Validations: { required: true },
        });
        if (!title_primary.valid) {
          setFormError("title", title_primary.error_msg);
          errors.push("title");
        }

        // error fields scroll up
        if (errors.length > 0) {
          const firstErrorField = errors[0];
          businessRefs[firstErrorField]?.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          return;
        }

      } else {
        const errors = [];

        // Type of Business
        const typeValidation = Validations({
          value: businessType,
          Validations: { required: true },
        });
        if (!typeValidation.valid) {
          setFormError("org_type", "This is required!");
          errors.push("org_type");
        }

        //Business address
        const add1BusinessValidation = Validations({
          value: formData.businessAddres1,
          Validations: { required: true },
        });
        const cityBusinessValidation = Validations({
          value: formData.businessAddresCity,
          Validations: { required: true },
        });
        const postCodeBusinessValidation = Validations({
          value: formData.businessAddresPostCode,
          Validations: { required: true },
        });
        const countryBusinessValidation = Validations({
          value: formData.businessAddresCountry,
          Validations: { required: true },
        });
        const stateBusinessValidation = Validations({
          value: formData.businessAddresState,
          Validations: { required: true },
        });
        //Business address
        if (!add1BusinessValidation.valid) {
          setFormError("businessAddres1", add1BusinessValidation.error_msg);
          errors.push("businessAddres1");
        }
        if (!cityBusinessValidation.valid) {
          setFormError("businessAddresCity", cityBusinessValidation.error_msg);
          errors.push("businessAddresCity");
        }
        if (!postCodeBusinessValidation.valid) {
          setFormError(
            "businessAddresPostCode",
            postCodeBusinessValidation.error_msg
          );
          errors.push("businessAddresPostCode");
        }
        if (!countryBusinessValidation.valid) {
          setFormError(
            "businessAddresCountry",
            countryBusinessValidation.error_msg
          );
          errors.push("businessAddresCountry");
        }
        if (!stateBusinessValidation.valid) {
          setFormError(
            "businessAddresState",
            stateBusinessValidation.error_msg
          );
          errors.push("businessAddresState");
        }

        // Details
        const nameValidation = Validations({
          value: formData.trading_name,
          Validations: { required: true },
        });
        const abnValidation = Validations({
          value: formData.abn_nzbn,
          Validations: { required: true, ValidateABN: true },
        });
        const ind_master_setting_id = Validations({
          value: formData.ind_master_setting_id,
          Validations: { required: true },
        });
        const requireNoEmpElse = ProviderContactData?.is_client_pay_licence === false;
        let no_of_emp;
        if (requireNoEmpElse) {
          no_of_emp = Validations({
            value: formData.no_of_emp,
            Validations: { required: true },
          });
        }
        // Details
        if (!nameValidation.valid) {
          setFormError("trading_name", nameValidation.error_msg);
          errors.push("trading_name");
        }
        if (!abnValidation.valid) {
          setFormError("abn_nzbn", abnValidation.error_msg);
          errors.push("abn_nzbn");
        }
        if (!ind_master_setting_id.valid) {
          setFormError(
            "ind_master_setting_id",
            ind_master_setting_id.error_msg
          );
          errors.push("ind_master_setting_id");
        }
        if (requireNoEmpElse) {
          if (!no_of_emp.valid) {
            setFormError("no_of_emp", no_of_emp.error_msg);
            errors.push("no_of_emp");
          }
        } else {
          setFormError("no_of_emp", "");
        }

        // Primary contact
        // const title_primary = Validations({
        //   value: contact?.[0]?.title,
        //   Validations: { required: true },
        // });
        // if (!title_primary.valid) {
        //   setFormError("title", title_primary.error_msg);
        //   errors.push("title");
        // }

        // error fields scroll up
        if (errors.length > 0) {
          const firstErrorField = errors[0];
          businessRefs[firstErrorField]?.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          return;
        }
      }
    }
  };

  const onAddDialogClose = () => {
    setdialogAddOpen(false);
  };

  useEffect(() => {
    dispatch(GetAllOrgIndustryTypeList()).then((response) => {
      let filterData = response?.data?.map((item) => {
        return { label: item.meta_value_one, value: item.master_setting_id };
      });
      setIndustoryOptions(filterData);
      // industoryOptions,
    });
  }, []);

  const showHandle = (e) => {
    if (e.target.value == "Primary") {
      setVisibleHide(false);
    } else {
      setVisibleHide(true);
    }
  };

  const AccBillingcontact = (val) => {
    setValue(val);
  };

  // const handleTitleChange = (e, name,billing) => {
  //   SetContact((prevFormData) => ({
  //     ...prevFormData,
  //     [name]: name == "title" ? e.value : e.target.value,
  //   }));
  // };

  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }

  const handleTitleChange = (e, name, billing) => {
    if (name != "title" && isValidEmail(e.target.value)) {
      dispatch(GetIndividualByEmail(e.target.value)).then((response) => {
        if (response.success && response.data) {
          if (response.data.is_conserve_team) {
            return;
          } else {
            setCheckEmail(true);
            SetContact((prevFormData) => {
              // Create a copy of the previous state array
              const newContact = [...prevFormData];
              // Update the specific object in the array
              newContact[1] = {
                ...newContact[1],
                ...response.data,
              };
              return newContact;
            });
            return;
          }
        } else {
          setCheckEmail(false);
        }
      });
    }
    const indexToUpdate = billing === "billing" ? 1 : 0; // Determine the index based on the billing value
    if (name == "title") {
      setFormError("title", "");
    }
    SetContact((prevFormData) => {
      // Create a copy of the previous state array
      const newContact = [...prevFormData];
      // Update the specific object in the array
      newContact[indexToUpdate] = {
        ...newContact[indexToUpdate],
        [name]: name === "title" ? e.value : e.target.value,
      };


      return newContact;
    });
  };

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Set flag to false after first render
    //   return; // Do nothing on the first render
    // }
    const payload = {
      detailsData: {
        org_type:
          businessType === "pty"
            ? "pty_traders"
            : businessType === "sole"
              ? "sole_traders"
              : "other", // Assuming businessType is one of "pty", "sole", or "other"
        trading_name: formData.trading_name,
        abn_nzbn: formData.abn_nzbn,
        no_of_emp: formData?.no_of_emp,
        ind_master_setting_id: formData?.ind_master_setting_id,
        // provider_org_detail_id: formData?.provider_org_detail_id,
      },
      provider_address_data: [
        {
          address_type: "business",
          address_one: formData.businessAddres1,
          address_two: formData.businessAddres2,
          suburb: formData.businessAddresCity,
          zipcode: formData.businessAddresPostCode,
          state_id: formData.businessAddresState,
          country_id: formData.businessAddresCountry,
          state_name: businessAddresState.label,
          country_name: businessAddresCountry.label,
        },
        {
          address_type: "mailing",
          address_one: sameAddress
            ? formData.businessAddres1
            : formData.mailingAddres1,
          address_two: sameAddress
            ? formData.businessAddres2
            : formData.mailingAddres2,
          suburb: sameAddress
            ? formData.businessAddresCity
            : formData.mailingAddresCity,
          zipcode: sameAddress
            ? formData.businessAddresPostCode
            : formData.mailingAddresPostCode,
          state_id: sameAddress
            ? formData.businessAddresState
            : formData.mailingAddresState,
          country_id: sameAddress
            ? formData.businessAddresCountry
            : formData.mailingAddresCountry,
          state_name: sameAddress
            ? businessAddresState.label
            : mailingAddresState.label,
          country_name: sameAddress
            ? businessAddresCountry.label
            : mailingAddresCountry.label,
        },
      ],
    };

    // Call the UpdateData function after first render
    UpdateData(payload, contact);
  }, [
    businessType,
    contact,
    formData,
    mailingAddresState,
    mailingAddresCountry,
    businessAddresState,
    businessAddresCountry,
  ]);

  useEffect(() => {
    if (formData?.businessAddres1 && sameAddress) {
      setFormErrors((prevError) => ({
        ...prevError,
        mailingAddres1: ""
      }))
    }
    // else if (formData?.businessAddres1 && !sameAddress && !formData?.mailingAddres1) {
    //   setFormErrors((prevError) => ({
    //     ...prevError,
    //     mailingAddres1: "This field is required!"
    //   }))
    // }
  }, [sameAddress])
  // useEffect(() => {
  //   if (visibleHide) {
  //     SetContact((prevValue) => {
  //       const newContact = [...prevValue];
  //       newContact[0] = {
  //         ...newContact[0],
  //         is_acc_billing_contact: true,
  //       },
  //       newContact[1]={
  //         providerContactType: "billing",
  //         is_acc_billing_contact: visibleHide,
  //         contact_title: "mr.",
  //         contact_first_name: "",
  //         contact_last_name: "",
  //         contact_phone: "",
  //         contact_phone_optional: "",
  //         contact_email: "",
  //       };
  //       return newContact;
  //     });
  //   }
  // }, [visibleHide]);

  useEffect(() => {
    SetContact((prevValue) => {
      const newContact = [...prevValue];
      if (visibleHide) {
        // Update the first contact object
        newContact[0] = {
          ...newContact[0],
        };
        // Add a new contact object
        newContact.push({
          providerContactType: "billing",
          title: "",
          first_name: "",
          last_name: "",
          phone: "",
          phone_optional: "",
          email: "",
          individual_id: "",
          contact_type_id: contactTypeData?.providerBilling,
        });
      } else {
        // Remove the second object if it exists
        if (newContact.length > 1) {
          newContact.splice(1, 1);
        }
      }
      if (newContact.length == 3) {
        newContact.splice(1, 1);
      }
      return newContact;
    });
  }, [visibleHide]);

  useEffect(() => {
    if (ProviderRegisterData?.data) {
      let address_data = ProviderRegisterData?.data?.provider_regist_data;
      SetContact(
        ProviderRegisterData?.data?.provider_regist_data?.individual_data
      );

      setBusinessType(address_data?.org_type);
      setFormData({
        trading_name: address_data?.trading_name,
        // provider_org_detail_id: "",
        abn_nzbn: address_data?.abn_nzbn,
        // acn: "",
        no_of_emp: address_data?.no_of_emp,
        ind_master_setting_id: address_data?.ind_master_setting_id,
        businessAddres1: address_data?.address_data[0]?.address_one,
        businessAddres2: address_data?.address_data[0]?.address_two,
        businessAddresCity: address_data?.address_data[0]?.suburb,
        businessAddresPostCode: address_data?.address_data[0]?.zipcode,
        businessAddresState: address_data?.address_data[0]?.state_id,
        businessAddresCountry: address_data?.address_data[0]?.country_id,
        businessId: "",

        mailingAddres1: address_data?.address_data[1]?.address_one,
        mailingAddres2: address_data?.address_data[1]?.address_two,
        mailingAddresCity: address_data?.address_data[1]?.suburb,
        mailingAddresPostCode: address_data?.address_data[1]?.zipcode,
        mailingAddresState: address_data?.address_data[1]?.state_id,
        mailingAddresCountry: address_data?.address_data[1]?.country_id,
        mailingId: "",
      });
      if (
        ProviderRegisterData?.data?.provider_regist_data?.individual_data
          .length >= 2
      ) {
        setVisibleHide(true);
        AccBillingcontact("Different");
        setValue("Different");
      }
    }
  }, [ProviderRegisterData]);

  useEffect(() => {
    if (RegistrationValidation) {
      submitClient();
    }
  }, [RegistrationValidation]);

  useEffect(() => {
    setTimeout(() => {
      if (ProviderContactData?.invitedProvider) {
        SetContact([
          {
            providerContactType: "primary",
            title: ProviderContactData?.title ? ProviderContactData?.title : "",
            first_name: ProviderContactData?.invitedProvider.first_name,
            last_name: ProviderContactData?.invitedProvider.last_name,
            phone: ProviderContactData?.invitedProvider?.phone || "",
            phone_optional: ProviderContactData?.invitedProvider?.phone_optional || "",
            email: ProviderContactData?.invitedProvider.email,
            password: ProviderContactData?.repeatPassword,
            individual_id: ProviderContactData?.individual_id,
            user_id: ProviderContactData?.invitedProvider?.user_id,
            contact_type_id: contactTypeData?.providerPrimary,
          },
        ]);
      }
      if (SignUpData.registrationType) {
        SetContact([
          {
            providerContactType: "primary",
            title: "",
            first_name: SignUpData.first_name,
            last_name: SignUpData.last_name,
            phone: SignUpData?.phone,
            phone_optional: "",
            email: SignUpData.email,
            password: SignUpData.password,
            individual_id: SignUpData?.individual_id,
            user_id: SignUpData?.invitedProvider?.user_id,
            contact_type_id: contactTypeData?.providerPrimary,
          },
        ]);
      }
    }, 0);
  }, [ProviderContactData, SignUpData]);
  return (
    <React.Fragment>
      <div className="flex justify-between mb-5">
        <h5 className="text-blue-800 font-semibold text-2xl">Your business</h5>
        {/* {settings_permissions && ( */}
        {/*permission for Read and Write */}
        {/* )} */}
      </div>
      <div className="items-start  mb-5">
        <p className="text-gray-700 font-bold text-base mb-4">
          Type of business
        </p>
        <div className="flex items-center">
          <Segment
            ref={businessRefs?.org_type}
            className="docType-btn"
            value={businessType}
            onChange={(val) => onBusinessType(val)}
          >
            <Segment.Item value="pty">
              <span>Pty Ltd</span>
            </Segment.Item>
            <Segment.Item value="sole">
              <span>Sole Trader</span>
            </Segment.Item>
            <Segment.Item value="other">
              <span>Other</span>
            </Segment.Item>
          </Segment>
        </div>
        {formErrors.org_type && (
          <p className="text-xs text-red-600 ">
            {formErrors.org_type}
          </p>
        )}
      </div>
      {/* <div className="flex items-start mb-5">
        <label className="text-gray-700 font-semibold w-2/12">Website</label>
        <div className="flex items-center w-8/12">
          <input
            className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline border-r-0 rounded-tr-none rounded-br-none"
            id="email"
            type="text"
            value={formData.website_url}
            onChange={(e) => inputchangehandler(e, "website_url")}
            onFocus={handleFocusWebsite}
          />
        </div>
      </div> */}
      <div className="items-start mb-5">
        <h4 className="font-bold text-gray-700 text-base mb-5">
          Business address
        </h4>
        <div className="flex items-center w-full flex-wrap">
          <div className="mb-5 w-full">
            <input
              ref={businessRefs?.businessAddres1}
              className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="text"
              type="text"
              placeholder="Street address*"
              value={formData.businessAddres1}
              onChange={(e) => inputchangehandler(e, "businessAddres1")}
            />
            {formErrors.businessAddres1 && (
              <p className="text-xs text-red-600 ">
                {formErrors.businessAddres1}
              </p>
            )}
          </div>
          <div className="flex w-full gap-2">
            <div className="w-1/3 mb-5">
              <input
                ref={businessRefs?.businessAddres2}
                className="input-shadow w-full h-10 text-sm border-gray-300 rounded-lg  appearance-none border py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline "
                id="text"
                type="text"
                placeholder="Apartment, suite, etc"
                value={formData.businessAddres2}
                onChange={(e) => inputchangehandler(e, "businessAddres2")}
              />
              {formErrors.businessAddres2 && (
                <p className="text-xs text-red-600 ">
                  {formErrors.businessAddres2}
                </p>
              )}
            </div>
            <div className="w-1/3 mb-5">
              <input
                ref={businessRefs?.businessAddresCity}
                className="input-shadow w-full h-10 text-sm border-gray-300 rounded-lg  appearance-none border py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="text"
                type="text"
                placeholder="Suburb*"
                value={formData.businessAddresCity}
                onChange={(e) => inputchangehandler(e, "businessAddresCity")}
              />
              {formErrors.businessAddresCity && (
                <p className="text-xs text-red-600 ">
                  {formErrors.businessAddresCity}
                </p>
              )}
            </div>
            <div className="w-1/3 mb-5">
              <input
                ref={businessRefs?.businessAddresPostCode}
                type="number"
                name="postcode"
                placeholder="Postcode*"
                className="input-shadow h-10 w-full text-sm border-gray-300 rounded-lg  appearance-none border py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={formData.businessAddresPostCode}
                onChange={(e) =>
                  inputchangehandler(e, "businessAddresPostCode")
                }
                maxLength={12}
              />
              {formErrors.businessAddresPostCode && (
                <p className="text-xs text-red-600 ">
                  {formErrors.businessAddresPostCode}
                </p>
              )}
            </div>
          </div>

          <div className="flex w-full gap-2">
            <div className="flex-1" ref={businessRefs?.businessAddresCountry}>
              <Select
                isSearchable={false}
                placeholder="Country*"
                options={allcountries}
                className="select-option w-full h-10 text-sm"
                value={allcountries?.filter(function (option) {
                  return option.value === formData.businessAddresCountry;
                })}
                onChange={(e) => handleCountryChange(e, "businessAddress")}
              />
              {formErrors.businessAddresCountry && (
                <p className="text-xs text-red-600">
                  {formErrors.businessAddresCountry}
                </p>
              )}
            </div>
            <div className="flex-1" ref={businessRefs?.businessAddresState}>
              <Select
                isSearchable={false}
                placeholder="State*"
                options={statesOne}
                className="select-option w-full h-10  mx-1 text-sm"
                value={statesOne?.filter(function (option) {
                  return option.value === formData.businessAddresState;
                })}
                onChange={(e) => handleStateChange(e, "businessAddress")}
              />

              {formErrors.businessAddresState && (
                <p className="text-xs text-red-600 ">
                  {formErrors.businessAddresState}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="items-start pb-5">
        <h4 className="font-bold text-gray-700 text-base mb-5">
          Mailing address
        </h4>
        <div className="flex items-center flex-1 flex-wrap">
          <div className="w-full mb-5">
            <input
              ref={businessRefs?.mailingAddres1}
              type="text"
              name="address"
              placeholder="Street address*"
              className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
              value={
                sameAddress
                  ? formData.businessAddres1
                  : formData?.mailingAddres1
              }
              onChange={(e) => inputchangehandler(e, "mailingAddres1")}
              readOnly={sameAddress ? true : false}
            />
            {formErrors.mailingAddres1 && (
              <p className="text-xs text-red-600 ">
                {formErrors.mailingAddres1}
              </p>
            )}
          </div>
          <div className="flex w-full gap-2">
            <div className="flex-1">
              <input
                ref={businessRefs?.mailingAddres2}
                type="text"
                name="Apartment"
                placeholder="Apartment, suite, etc (optional)"
                className="mb-2 input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                value={
                  sameAddress
                    ? formData.businessAddres2
                    : formData?.mailingAddres2
                }
                onChange={(e) => inputchangehandler(e, "mailingAddres2")}
                readOnly={sameAddress ? true : false}
              />
              {formErrors.mailingAddres2 && (
                <p className="text-xs text-red-600 ">
                  {formErrors.mailingAddres2}
                </p>
              )}{" "}
            </div>
            <div className="flex-1 mb-5">
              <input
                ref={businessRefs?.mailingAddresCity}
                type="text"
                name="Suburb"
                placeholder="Suburb*"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                value={
                  sameAddress
                    ? formData.businessAddresCity
                    : formData?.mailingAddresCity
                }
                onChange={(e) => inputchangehandler(e, "mailingAddresCity")}
                readOnly={sameAddress ? true : false}
              />
              {!sameAddress && formErrors.mailingAddresCity && (
                <p className="text-xs text-red-600 ">
                  {formErrors.mailingAddresCity}
                </p>
              )}
            </div>
          </div>
          <div className="flex w-full gap-2">
            <div className=" flex-1 h-9" ref={businessRefs?.mailingAddresCountry}>
              <Select
                isSearchable={false}
                placeholder="Country*"
                readOnly={sameAddress ? true : false}
                options={countryOptions}
                className="select-option flex-1 h-9 text-sm"
                value={
                  sameAddress
                    ? allcountries?.filter(function (option) {
                      return option.value === formData.businessAddresCountry;
                    })
                    : countryOptions?.filter(function (option) {
                      return option.value === formData?.mailingAddresCountry;
                    })
                }
                onChange={(e) => handleCountryChange(e, "mailingAddress")}
              />
              {!sameAddress && formErrors.mailingAddresCountry && (
                <p className="text-xs text-red-600 ">
                  {formErrors.mailingAddresCountry}
                </p>
              )}
            </div>
            <div className="flex-1 mb-5" >
              <input
                ref={businessRefs?.mailingAddresPostCode}
                type="number"
                name="Postcode"
                placeholder="Postcode*"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
                value={
                  sameAddress
                    ? formData.businessAddresPostCode
                    : formData?.mailingAddresPostCode
                }
                onChange={(e) => inputchangehandler(e, "mailingAddresPostCode")}
                readOnly={sameAddress ? true : false}
                maxLength={12}
              />
              {!sameAddress && formErrors.mailingAddresPostCode && (
                <p className="text-xs text-red-600 ">
                  {formErrors.mailingAddresPostCode}
                </p>
              )}
            </div>
          </div>
          <div className="w-full h-9" ref={businessRefs?.mailingAddresState}>
            <Select
              isSearchable={false}
              placeholder="State*"
              options={StateOptions2}
              readOnly={sameAddress ? true : false}
              className="select-option h-10 text-sm border-gray-300 rounded-lg  appearance-none w-full text-gray-900 leading-tight focus:outline-none focus:shadow-outline"
              value={
                sameAddress
                  ? statesOne?.filter(function (option) {
                    return option.value === formData.businessAddresState;
                  })
                  : StateOptions2?.filter(function (option) {
                    return option.value === formData.mailingAddresState;
                  })
              }
              onChange={(e) => handleStateChange(e, "mailingAddress")}
            />

            {!sameAddress && formErrors.mailingAddresState && (
              <p className="text-xs text-red-600 ">
                {formErrors.mailingAddresState}
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="mb-4">
        <input
          className="checkbox rounded"
          type="checkbox"
          value={sameAddress ? sameAddress : false}
          checked={sameAddress ? sameAddress : false}
          onChange={() => setSameAddress(!sameAddress)}
        />
        <label className="text-gray-700 font-medium pb-3">
          Mailing address same as business address
        </label>{" "}
      </div>
      {formErrors.existClient && (
        <p className="text-xs text-red-600  pt-8">{formErrors.existClient}</p>
      )}
      <h4 className="font-bold text-gray-700 text-base mb-4 mt-1">Details</h4>
      <div className="items-start  mb-5">
        <label
          className="block text-gray-700  mb-2 text-xs font-medium"
          for="password"
        >
          Entity name*        </label>
        <div className=" items-center w-full">
          <input
            ref={businessRefs?.trading_name}
            className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            id="text"
            type="text"
            placeholder="Enter business name here"
            value={formData.trading_name}
            // readOnly
            onChange={(e) => inputchangehandler(e, "trading_name")}
          />
          {formErrors.trading_name && (
            <p className="text-xs text-red-600 ">{formErrors.trading_name}</p>
          )}
        </div>
      </div>
      <div className="items-start mb-5">
        <label className="block text-gray-700  mb-2 text-xs font-medium">
          ABN/NZBN*
        </label>
        <div className=" items-center w-full">
          <input
            className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            // id="abn_nzbn"
            ref={businessRefs?.abn_nzbn}
            disabled={ProviderContactData?.provider_abn_nzbn ? true : false}
            type="number"
            placeholder="Enter ABN/NZBN here"
            value={formData.abn_nzbn}
            onChange={(e) => inputchangehandler(e, "abn_nzbn")}
            // onBlur={handleABN}
            maxLength="14"
            minLength="11"
            onKeyDown={preventInvalidChars}
          />
          {formErrors.abn_nzbn && (
            <p className="text-xs text-red-600 ">{formErrors.abn_nzbn}</p>
          )}
        </div>
      </div>
      <div className="items-start mb-5">
        <label className="block text-gray-700  mb-2 text-xs font-medium">
          Industry*
        </label>
        <div className="flex items-center w-full flex-wrap" ref={businessRefs?.ind_master_setting_id}>
          <Select
            className="w-full h-10 select-options"
            placeholder="Industry name here"
            value={
              industoryOptions?.filter(
                (item) => item.value == formData.ind_master_setting_id
              )[0]
            }
            options={industoryOptions}
            onChange={(e) => inputchangehandler(e, "ind_master_setting_id")}
          ></Select>
          {formErrors.ind_master_setting_id && (
            <p className="text-xs text-red-600 ">
              {formErrors.ind_master_setting_id}
            </p>
          )}
        </div>
      </div>

      {ProviderContactData?.is_client_pay_licence === false && (
        <div className="items-start mb-5" ref={businessRefs?.no_of_emp}>
          <label className="block text-gray-700  mb-2 text-xs font-medium">
            How many workers would you like to register for this client?*
          </label>

          <input
            className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            ref={businessRefs?.no_of_emp}
            type="number"
            placeholder="Enter number of workers here"
            value={formData.no_of_emp}
            onChange={(e) => inputchangehandler(e, "no_of_emp")}
            maxLength="14"
            minLength="11"
            onKeyDown={preventInvalidChars}
          />

          {formErrors.no_of_emp && (
            <p className="text-xs text-red-600 ">{formErrors.no_of_emp}</p>
          )}
        </div>
      )}

      <h4 className="font-bold text-gray-700 text-base mb-5 mt-7">
        Primary contact*
      </h4>
      <div className="items-start  mb-5">
        {/* <Label className="font-semibold w-72 font-sm">WHS Contact</Label> */}
        <div className="Pflex items-center  flex-1 flex-wrap">
          <div className="flex w-full gap-2">
            {/* <div className=" w-1/5 " ref={businessRefs?.title}>
              <Select
                isSearchable={false}
                placeholder="Title*"
                // readOnly={true}
                options={TitleOptions}
                className="select-option w-full  h-9"
                // value={
                //   TitleOptions &&
                //   TitleOptions.filter(
                //     (options) => options.value === contact[0]?.title
                //   )
                // }
                value={
                  TitleOptions.find(
                    (option) => option.value === contact[0]?.title
                  )
                }
                onChange={(e) => handleTitleChange(e, "title")}
              />
              {formErrors.title && (
                <p className="text-xs text-red-600 ">
                  {formErrors.title}
                </p>
              )}
            </div> */}
            <input
              type="text"
              name="First name"
              disabled={true}
              // className="w-5/12"
              placeholder="First name*"
              className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-1/2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
              value={contact[0]?.first_name}
              onChange={(e) => handleTitleChange(e, "first_name")}
            />
            <input
              type="text"
              name="Last name"
              disabled={true}
              // className="w-5/12"
              placeholder="Last name*"
              className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-1/2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
              value={contact[0]?.last_name}
              onChange={(e) => handleTitleChange(e, "last_name")}
            />
          </div>
          <div className="flex w-full gap-2">
            <input
              type="text"
              name="Phone"
              placeholder="Mobile"
              disabled={true}
              className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-1/2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
              value={contact[0]?.phone}
              onChange={(e) => handleTitleChange(e, "phone")}
              onKeyDown={preventInvalidChars}
            />

            <input
              type="text"
              name="Email"
              placeholder="Email"
              disabled={true}
              className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-1/2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
              value={contact[0]?.email}
              onChange={(e) => handleTitleChange(e, "email")}
            />
          </div>
        </div>
      </div>
      <h4 className="font-bold text-gray-700 text-base mb-2 mt-7 flex items-center gap-2">
        Account billing contact
        <Tooltip
          title="Account billing contact is responsible for billing and payment on the account."
          placement="top-start"
        >
          <div className="text-center cursor-pointer">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#bcclap1iaa)">
                <path
                  d="M6.06 6a2 2 0 0 1 3.887.667c0 1.333-2 2-2 2M8 11.333h.007M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0z"
                  stroke="#98A2B3"
                  stroke-width="1.333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="bcclap1iaa">
                  <path fill="#fff" d="M0 0h16v16H0z" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </Tooltip>
      </h4>
      <div className="">
        <Radio.Group vertical value={value} onChange={AccBillingcontact}>
          <Radio onClick={showHandle} value={"Primary"} className="flex gap-2">
            Same as primary contact
          </Radio>
          <Radio
            onClick={showHandle}
            value={"Different"}
            className="flex gap-2"
          >
            Different contact
          </Radio>
        </Radio.Group>
      </div>

      {visibleHide && (
        <React.Fragment>
          <div className="Pflex items-center  flex-1 flex-wrap">
            <h4 className="font-bold text-gray-700 text-base mb-4 mt-5">
              Billing contact*
            </h4>
            <div className="flex w-full gap-2">
              <Select
                isSearchable={false}
                placeholder="Title"
                options={TitleOptions}
                className="select-option w-2/12 mb-5"
                // value={
                //   TitleOptions &&
                //   TitleOptions.filter(
                //     (options) => options.value === contact[1]?.title
                //   )
                // }
                value={
                  TitleOptions.find(
                    (option) => option.value === contact[0]?.title
                  )
                }
                onChange={(e) => handleTitleChange(e, "title", "billing")}
              />
              <input
                type="text"
                name="First name"
                disabled={checkEmail}
                placeholder="First name*"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-5/12 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
                value={contact[1]?.first_name}
                onChange={(e) => handleTitleChange(e, "first_name", "billing")}
              />
              <input
                type="text"
                name="Last name"
                disabled={checkEmail}
                placeholder="Last name*"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-5/12 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
                value={contact[1]?.last_name}
                onChange={(e) => handleTitleChange(e, "last_name", "billing")}
              />
            </div>
            <div className="flex w-full gap-2">
              <input
                type="number"
                name="Work"
                disabled={checkEmail}
                placeholder="Work*"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
                value={contact[1]?.phone}
                onChange={(e) => handleTitleChange(e, "phone", "billing")}
                onKeyDown={preventInvalidChars}
              />

              <input
                type="number"
                disabled={checkEmail}
                placeholder="Mobile (optional)"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
                value={contact[1]?.phone_optional}
                onChange={(e) =>
                  handleTitleChange(e, "phone_optional", "billing")
                }
                onKeyDown={preventInvalidChars}
              />
            </div>
            <div className="flex w-full h-9">
              <input
                type="text"
                name="Email"
                placeholder="Email"
                className="input-shadow h-10 text-sm border-gray-300 rounded-lg  appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-5"
                value={contact[1]?.email}
                onChange={(e) => handleTitleChange(e, "email", "billing")}
              />
            </div>
          </div>
        </React.Fragment>
      )}
      <Dialog
        isOpen={dialogAddOpen}
        onClose={onAddDialogClose}
        onRequestClose={onAddDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
            >
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                fill="#D1FADF"
              />
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                stroke="#ECFDF3"
              />
              <path
                d="M32.083 18.8721L21.083 29.8721L16.083 24.8721"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            Company profile has been saved successfully
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => onAddDialogClose()}>Close</BtnLight>
        </div>
      </Dialog>
    </React.Fragment>
  );
};
export default YourBusiness;
